module.exports = "<div class=\"container\">\n  <mat-card class=\"mat-elevation-z8\">\n      <router-outlet></router-outlet>\n  </mat-card>\n</div>"